import Select from 'react-select';
import styled from 'styled-components';
import { ErrorMessage } from 'Components/Common/styled';

const SelectWrapper = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
`;

const customStyles = {
  placeholder: (base: any) => ({
    ...base,
    color: '#C4C4C4',
    fontSize: '16px',
    fontWeight: 500,
    fontFamily: 'Inter',
  }),
  control: (base: any, state: any) => ({
    ...base,
    fontFamily: 'Inter',
    fontWeight: 500,
    height: 50,
    minHeight: 50,
    width: '100%',
    boxShadow: 'none',
    // backgroundColor: state.hasValue ? "var(--lightBlueBackground)" : "transparent",
    borderColor: state.isFocused ? 'var(--primary)' : 'var(--defaultBorderColor)',
    '&:hover': { borderColor: state.isFocused ? 'var(--primary)' : 'var(--defaultBorderColor)' },
  }),
  option: (base: any, state: any) => {
    return {
      ...base,
      fontFamily: 'Inter',
      fontWeight: 500,
      fontSize: '14px',
      borderColor: 'var(--primary)',
      backgroundColor: state.isFocused ? 'var(--primary)' : 'var(--white)',
      ':active': {
        backgroundColor: state.isSelected ? 'var(--white)' : 'var(--primary)',
      },
      color: state.isFocused ? 'var(--white)' : 'var(--black)',
    };
  },
};

const errorStyles = {
  control: (base: any) => ({
    ...base,
    height: 50,
    minHeight: 50,
    width: '100%',
    boxShadow: 'none',
    borderColor: 'var(--errorRed)',
    '&:hover': { borderColor: 'var(--errorRed)' },
  }),
};

interface selectComponentProps {
  options: any;
  name: string;
  placeholder: string;
  onChange: (e: any) => void;
  value?: string;
  error?: string;
  isCustomValue?: boolean;
  isSearchable?: boolean;
  className?: string;
  menuPlacement?: 'top' | 'bottom' | 'auto';
  defaultValue?: any;
}

const SelectComponent: React.FC<selectComponentProps> = ({
  name,
  placeholder,
  onChange,
  options,
  value,
  error,
  isSearchable,
  className,
  defaultValue,
  isCustomValue = true,
  menuPlacement = 'auto',
}) => {
  const handleChange = (selectedOption: any) => {
    onChange({
      name,
      label: selectedOption.label,
      value: selectedOption.value,
    });
  };

  return (
    <SelectWrapper className={className} data-testid="reactSelectWrapper">
      <Select
        defaultValue={defaultValue}
        menuPlacement={menuPlacement}
        styles={{ ...customStyles, ...(error && errorStyles) }}
        name={name}
        placeholder={placeholder}
        onChange={handleChange}
        options={options}
        {...(value && isCustomValue
          ? {
              value: {
                value: value,
                label: options.find((option: any) => option.value === value)?.label,
              },
            }
          : {})}
        isSearchable={isSearchable}
      />
      {!!error && <ErrorMessage>{error}</ErrorMessage>}
    </SelectWrapper>
  );
};

export default SelectComponent;
